import React, { Fragment } from 'react';
import * as repr from '../../api/types';
import t from '../../localization/i18n';
import { isGif } from '../helpers';

interface PropsShape {
    report: repr.Report;
}

export default class ImportantInfoText extends React.Component<PropsShape> {
    render() {
        const { investmentType, includeGIA, productType } = this.props.report;

        return (
		<>
                {
                includeGIA || isGif(productType)
                    ? t(`report.importantInfo.textInvestmentPlus`)
                    : t(`report.importantInfo.text${investmentType}`)
                }
            </>
        );
    }
}